const CRSClassificationStatus = [
  { value: 1, name: 'Individual', description: 'Individual' },
  { value: 2, name: 'FiInvestmentEntity', description: 'Financial Institution - Investment Entity' },
  { value: 3, name: 'FiOther', description: 'Financial Institution - Other' },
  { value: 4, name: 'ActiveNfeRegularlyTraded', description: 'Active NFE - Regularly Traded' },
  { value: 5, name: 'ActiveNfeGovernmentEntityOrCentralBank', description: 'Active NFE - Government Entity or Central Bank' },
  { value: 6, name: 'ActiveNfeInternationalOrganisation', description: 'Active NFE - International Organisation' },
  { value: 7, name: 'ActiveNfeOther', description: 'Active NFE - Other' },
  { value: 8, name: 'PassiveNfe', description: 'Passive NFE' },
  { value: 9, name: 'ControllingPerson', description: 'Controlling Person' },
];

export default CRSClassificationStatus;
